import React from 'react';
import { css } from '@emotion/core';
import { setTextVariantStyle } from 'utils/variantStyle';
import { white } from 'Mui/styles/color';
import i18n from 'i18next';
import useContainerWidth from 'client/hooks/useContainerWidth';

const VerifyPendingBanner = ({ text }) => {
    const { maxWidth } = useContainerWidth();
    return (
        <div css={labelStyle(maxWidth)}>
            {text || i18n.t('label.verify_mechanism.verify_prompt_default')}
        </div>
    );
};

export default VerifyPendingBanner;

const labelStyle = maxWidth => css`
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: min(${maxWidth}px, 100%);
    z-index: 3;
    color: ${white.color};
    font-size: 2rem;
    padding: 6px 10px;
    background: rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    ${setTextVariantStyle('subtitle2')}
`;
